export const PATIENT_SELECTION_STORAGE_KEY_PREFIX = 'patient_selection_'
export const PROVIDER_SELECTION_STORAGE_KEY_PREFIX = 'provider_selection_'
export const PATIENT_TRAY_UI_STORAGE_KEY_PREFIX = 'patient_tray_ui_'

const WORKSPACE_SELECTION_PREFIXES: readonly string[] = [
  PATIENT_SELECTION_STORAGE_KEY_PREFIX,
  PROVIDER_SELECTION_STORAGE_KEY_PREFIX,
  PATIENT_TRAY_UI_STORAGE_KEY_PREFIX,
]

export type PersistedPatientSelection = {
  selectedPatientId: string | null
  selectedPatientIds: string[]
  isPatientSidePanelOpen: boolean
}

export const patientSelectionStorageKey = (clinicId: string): string =>
  `${PATIENT_SELECTION_STORAGE_KEY_PREFIX}${clinicId}`

export const readPersistedPatientSelection = (
  clinicId: string | undefined,
): PersistedPatientSelection | null => {
  if (!clinicId) return null
  try {
    const raw = sessionStorage.getItem(patientSelectionStorageKey(clinicId))
    if (!raw) return null
    const saved = JSON.parse(raw) as PersistedPatientSelection
    if (!saved || typeof saved !== 'object') return null
    return saved
  } catch {
    return null
  }
}

export const hasPersistedPatientSelection = (
  clinicId: string | undefined,
): boolean => {
  const saved = readPersistedPatientSelection(clinicId)
  if (!saved) return false
  return (
    Boolean(saved.selectedPatientId) ||
    (Array.isArray(saved.selectedPatientIds) &&
      saved.selectedPatientIds.length > 0)
  )
}

export const clearPersistedWorkspaceSelection = (): void => {
  if (typeof sessionStorage === 'undefined') return
  const keysToRemove: string[] = []
  for (let index = 0; index < sessionStorage.length; index += 1) {
    const key = sessionStorage.key(index)
    if (
      key &&
      WORKSPACE_SELECTION_PREFIXES.some((prefix) => key.startsWith(prefix))
    ) {
      keysToRemove.push(key)
    }
  }
  keysToRemove.forEach((key) => sessionStorage.removeItem(key))
}
